module.exports = __webpack_public_path__ + "static/media/pt-aigfutura-bookitalic-webfont.b26c4d0e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pt-aigfutura-bookitalic-webfont.svg
// module id = 375
// module chunks = 3